export default {
  label: '采矿技术员',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '采矿技术员是采矿领域中的技术支持和操作人员，主要负责协助采矿工程师进行地质勘探、资源评估以及采矿规划和设计等工作',
          id: '0-1-1',
        }
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '协助采矿工程师进行地质勘探和资源评估，参与采矿规划和设计',
          id: '0-2-1',
        },
        {
          label: '收集、整理和分析地质数据，为采矿决策提供支持',
          id: '0-2-2'
        },
        {
          label: '监控矿山生产过程，收集并分析生产数据，确保安全高效地开采矿产资源',
          id: '0-2-3'
        },
        {
          label: '负责矿山开拓、采准、采矿、充填、通风、排水、运输、提升系统的技术设计与施工监督',
          id: '0-2-4'
        },
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '掌握采矿工程相关专业知识，如矿山开采设计、岩层控制技术及工程设计能力',
          id: '0-3-1',
        },
        {
          label: '具备良好的沟通能力和团队协作精神，能够适应井下工作环境',
          id: '0-3-2',
        }
      ],
    },
    {
      label: '薪资水平',
      id: '0-4',
      children: [
        {
          label: '应届生：约为6000元',
          id: '0-4-1',
        },
        {
          label: '采矿工程硕士：起薪在8000-12000元',
          id: '0-4-2',
        }
      ],
    },
    {
      label: '晋升方向',
      id: '0-5',
      children: [
        {
          label: '采矿工程师',
          id: '0-5-1',
        }
      ],
    }
  ],
};